import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMessage: "",
      snackBar: {
        type: "error",
        message: "",
      },
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: true,
      errorMessage: error.message,
      snackBar: {
        type: "error",
        message: error.message,
      },
    });

    // Use requestAnimationFrame instead of DOMContentLoaded
    requestAnimationFrame(() => {
      const snackbar = document.getElementById("snackbar-shell-1");
      if (snackbar) {
        snackbar.open = true;
        snackbar.message = "Something Went Wrong.";
      }
    });
  }

  render() {
    const { type } = this.state.snackBar;

    if (this.state.hasError) {
      return null;
    }

    return (
      <React.Fragment>
        <se-snackbar
          key="snackbar"
          id="snackbar-shell-1"
          type={type}
          icon="information_stroke"
          duration="3000"
        />
        {this.props.children}
      </React.Fragment>
    );
  }
}

export default ErrorBoundary;